import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AddCompanyComponent } from 'src/app/AddThings/add-company/add-company.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';
import { CustomerCount, CustomerService } from 'src/services/customer.service';
import { ManageCompanyAccessComponent } from '../manage-company-access/manage-company-access.component';
import { UpdateCompanyComponent } from '../update-company/update-company.component';

@Component({
    selector: 'app-company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.scss'],
    standalone: false
})
export class CompanyListComponent implements OnInit {
  private router = inject(Router);
  protected enums = inject(Enums);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private customerService = inject(CustomerService);
  private companyService = inject(CompanyService);

  companyList: Company[] = [];

  displayedColumns: string[] = ['CompanyCode'];
  dataSource = new MatTableDataSource<Company>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  loggedInRoleID: number;

  ngOnInit(): void {
    this.getAllCompanies();

    this.loggedInRoleID = Number(sessionStorage.getItem('roleId'));

    //IF LOGGED IN USER IS ADMIN, ADD 'ACTIONS' COLOUMN
    if (this.sharedService.isAdmin() || this.sharedService.isBossAccount() || this.sharedService.isAuditor() || this.sharedService.isFinance()) {
      this.displayedColumns.push("Actions");

    }

  }

  async getAllCompanies() {
    let custCount: CustomerCount[] = [];
    [this.companyList, custCount] = await Promise.all([
      this.companyService.getAllCompanies(),
      this.customerService.getCustomerCount({ verified: false })
    ]);

    custCount.forEach(c => {
      const comp = this.companyList.find(t => t.ID === c.CompanyId);
      if (comp) {
        comp.UnverifiedCutsomerCount = c.Count;
      }
    });

    this.dataSource = new MatTableDataSource<Company>(this.companyList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSourceSort();
  }

  async getCompUnverifiedCustCount(comp: Company) {
    comp.UnverifiedCutsomerCount = (await this.customerService.getCompCustomerCount(comp.ID, { verified: false }))?.Count;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openAddCompanyDialog() {

    const modalRef = this.sharedService.openModal(AddCompanyComponent, 'regularModal');

    //get company that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const company = entry;

      //append added company to company list
      this.companyList.push(company);
      // console.log(JSON.stringify(this.companyList));
    });

    modalRef.result.then(() => {
      // this.cdr.detectChanges();
      this.refreshDataSource();
    })
  }

  confirmDeleteCompany(company: Company) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete this company (" + company.Name + ") ?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteCompany(company);
    });
  }

  deleteCompany(company: Company) {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/company/" + company.ID;
    // xhttp.open("DELETE", url, true);
    // xhttp.withCredentials = true;
    // xhttp.setRequestHeader("Content-type", "application/json");

    const xhttp = this.restapi.deleteRequest(this.constructApi.getDeleteCompany(company.ID))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:
        //  document.getElementById("demo").innerHTML = xhttp.responseText;
        // console.log(this.responseText);

        for (const i in this.companyList) {
          if (this.companyList[i].ID == company.ID) {
            this.companyList.splice(Number(i), 1);
            // this.cdr.detectChanges();

            this.refreshDataSource();

          }
        }

      }
    };

    // xhttp.send();

  }

  openUpdateCompanyModal(company: Company) {
    const modalRef = this.sharedService.openModal(UpdateCompanyComponent, 'regularModal')

    //pass value to edit form
    modalRef.componentInstance.companyId = company.ID;
    // modalRef.componentInstance.companyName = company.Name;
    // modalRef.componentInstance.phoneNumber = company.ContactNo;
    // modalRef.componentInstance.address = company.Address;
    // modalRef.componentInstance.companyCode = company.CompanyCode;
    // modalRef.componentInstance.regNum = company.RegNum;

    //get company that was updated
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const updateCompany = entry;
      this.companyList.splice(this.companyList.indexOf(company), 1, updateCompany);
      this.getCompUnverifiedCustCount(updateCompany);
    });

    modalRef.result.then(() => {
      // console.log("added task")
      // this.cdr.detectChanges();
      this.refreshDataSource();
    })

  }

  refreshDataSource() {
    // this.dataSource = null
    // this.dataSource = new MatTableDataSource<Company>(this.companyList);
    this.dataSource.data = this.companyList;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSourceSort();
  }

  viewCustomerList(companyID: number) {
    this.router.navigate(['/customerList', companyID]);
  }

  viewUnverifiedCustomerList(companyID: number) {
    this.router.navigate(['/unverfiedCustomerList', companyID, false]);
  }

  openCompanyAccessModal(companyID: number, companyCode:string) {
    const modalRef = this.sharedService.openModal(ManageCompanyAccessComponent, "largeModal");
    modalRef.componentInstance.selectedCompany = companyID;
    modalRef.componentInstance.selectedCompanyCode = companyCode;
  }

  dataSourceSort() {

    this.dataSource.sortingDataAccessor = (item, property) => {

      switch (property) {
        case 'Actions':
          //if sort by action column, sort VERIFIED
          if (item["UnverifiedCutsomerCount"] != undefined)
            return item["UnverifiedCutsomerCount"]
          else {
            return 0
          }

        default:
          return item[property];
      }
    };
  }
}
